import { Box, styled } from '@mui/material';

export const NoResultContainer = styled(Box)`
  width: 100%;
  height: fit-content;
`;
